module.exports = __webpack_public_path__ + "img/trending-news-3.e5b9b681.jpg";